export default {"src":"/_next/static/media/image 5.ea3a9a1d.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};